import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'property-reviews';

export function onViewPropertyClick(listingid, position) {
    const fastPathEvent = {
        action_location: ACTION_LOCATION,
        listingid,
        event_refinements: `position:${position}`,
    };
    return () => {
        pushEdapEvent('content_tile.selected', fastPathEvent);
    };
}
